import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-basis: 0;\n  min-height: 60px;\n\n  ", "\n\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  width: 100%;\n  border-top: 1px solid ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  width: 420px;\n  justify-content: flex-end;\n\n  @media screen and (max-width: ", "px) {\n    width: calc(100% - 70px);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { Button, ButtonLink } from '../Button';
import styled from '../utils/styling/styled-components';
import { BUTTON } from '../utils/testing/TestIDs';
import { ButtonStyle } from './types';
import { Modal } from './Modal';
var StyledModal = styled(Modal)(_templateObject(), function (props) {
  return props.theme.breakpoints.sm;
});
var ButtonContainer = styled.footer(_templateObject2(), function (props) {
  return props.buttonStyle;
}, function (props) {
  return props.theme.colors.ivory;
});
var StyledButton = styled(Button)(_templateObject3(), function (props) {
  return props.buttonStyle === ButtonStyle.row ? "\n        border-right: 1px solid ".concat(props.theme.colors.ivory, ";\n\n        &:last-child {\n          border-right: none;\n        }\n      ") : "\n        border-bottom: 1px solid ".concat(props.theme.colors.ivory, ";\n\n        &:last-child {\n          border-bottom: none;\n        }\n      ");
}, function (props) {
  return props.secondary ? "\n        &:hover {\n          border-color: ".concat(props.theme.colors.ivory, ";\n        }\n      ") : "";
});
var StyledLinks = StyledButton.withComponent(ButtonLink);

var ConfirmationModalBase = function ConfirmationModalBase(_ref) {
  var actions = _ref.actions,
      _ref$buttonStyle = _ref.buttonStyle,
      buttonStyle = _ref$buttonStyle === void 0 ? ButtonStyle.row : _ref$buttonStyle,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["actions", "buttonStyle", "children"]);

  return /*#__PURE__*/React.createElement(StyledModal, rest, children, /*#__PURE__*/React.createElement(ButtonContainer, {
    buttonStyle: buttonStyle
  }, actions === null || actions === void 0 ? void 0 : actions.map(function (action, index) {
    var isLink = !!action.href;

    if (isLink && typeof action.href === 'string') {
      return /*#__PURE__*/React.createElement(StyledLinks, {
        buttonStyle: buttonStyle,
        "data-testid": action.testId || "".concat(BUTTON, "_").concat(index),
        href: action.href,
        key: action.label,
        rel: "noopener noreferrer",
        secondary: action.type === 'secondary',
        target: "_blank",
        tertiary: action.type === 'danger',
        type: "flat"
      }, action.label);
    }

    if (isLink && typeof action.href !== 'string') {
      return /*#__PURE__*/React.createElement(StyledLinks, {
        buttonStyle: buttonStyle,
        "data-testid": action.testId || "".concat(BUTTON, "_").concat(index),
        href: action.href.url,
        key: action.label,
        rel: action.href.rel,
        secondary: action.type === 'secondary',
        target: action.href.target,
        tertiary: action.type === 'danger',
        type: "flat"
      }, action.label);
    }

    return /*#__PURE__*/React.createElement(StyledButton, {
      buttonStyle: buttonStyle,
      "data-testid": action.testId || "".concat(BUTTON, "_").concat(index),
      key: action.label,
      onPress: action.handler,
      secondary: action.type === 'secondary',
      tertiary: action.type === 'danger',
      type: "flat"
    }, action.label);
  })));
};

export { ButtonContainer, ConfirmationModalBase, StyledButton, StyledLinks, StyledModal };